import React, { forwardRef } from 'react'
import { ReactComponent as EmptySVG } from './empty.svg'

export const EmptyIcon = forwardRef<SVGSVGElement, React.PropsWithChildren<{}>>((props, ref) => {
  return <EmptySVG ref={ref} {...props} />
})
